import { UserHelper } from './Techedge-digitalportal-shared'

export const canCreate = UserHelper._shared().userAbilityHelper.canCreate
export const canCreateReleased =
    UserHelper._shared().userAbilityHelper.canCreateReleased
export const canCreateActivity =
    UserHelper._shared().userAbilityHelper.canCreateActivity
export const canCreateTask =
    UserHelper._shared().userAbilityHelper.canCreateTask
export const canCreateNews =
    UserHelper._shared().userAbilityHelper.canCreateNews
export const canCreateVisit =
    UserHelper._shared().userAbilityHelper.canCreateVisit
export const hasMysteryVisitDisabled =
    UserHelper._shared().userAbilityHelper.hasMysteryVisitDisabled
export const canCreateReleasedTask =
    UserHelper._shared().userAbilityHelper.canCreateReleasedTask
export const canCreateReleasedNews =
    UserHelper._shared().userAbilityHelper.canCreateReleasedNews
export const canCreateReleasedVisit =
    UserHelper._shared().userAbilityHelper.canCreateReleasedVisit
export const canCreatePhoto =
    UserHelper._shared().userAbilityHelper.canCreatePhoto
export const canCreateTopic =
    UserHelper._shared().userAbilityHelper.canCreateTopic
export const canCreateThread =
    UserHelper._shared().userAbilityHelper.canCreateThread
export const canCreateMessage =
    UserHelper._shared().userAbilityHelper.canCreateMessage
export const canCreateQuickLink =
    UserHelper._shared().userAbilityHelper.canCreateQuickLink
export const canCreateAsDraft =
    UserHelper._shared().userAbilityHelper.canCreateAsDraft
export const canCreateAsDraftTask =
    UserHelper._shared().userAbilityHelper.canCreateAsDraftTask
export const canCreateAsDraftNews =
    UserHelper._shared().userAbilityHelper.canCreateAsDraftNews
export const canEdit = UserHelper._shared().userAbilityHelper.canEdit
export const canEditTask = UserHelper._shared().userAbilityHelper.canEditTask
export const canEditNews = UserHelper._shared().userAbilityHelper.canEditNews
export const canEditQuickLink =
    UserHelper._shared().userAbilityHelper.canEditQuickLink
export const canEditThread =
    UserHelper._shared().userAbilityHelper.canEditThread
export const canEditTopic = UserHelper._shared().userAbilityHelper.canEditTopic
export const canSaveDraft = UserHelper._shared().userAbilityHelper.canSaveDraft
export const canSaveAsToBeReleased =
    UserHelper._shared().userAbilityHelper.canSaveAsToBeReleased
export const canSaveDraftNews =
    UserHelper._shared().userAbilityHelper.canSaveDraftNews
export const canSaveDraftTask =
    UserHelper._shared().userAbilityHelper.canSaveDraftTask
UserHelper._shared().userAbilityHelper.canSaveDraftNews
export const canSaveAsToBeReleasedTask =
    UserHelper._shared().userAbilityHelper.canSaveAsToBeReleasedTask
export const canSaveAsToBeReleasedNews =
    UserHelper._shared().userAbilityHelper.canSaveAsToBeReleasedNews
export const canSendInApproval =
    UserHelper._shared().userAbilityHelper.canSendInApproval
export const canSendInApprovalPhotographicTask =
    UserHelper._shared().userAbilityHelper.canSendInApprovalPhotographicTask
export const canAcceptApproval =
    UserHelper._shared().userAbilityHelper.canAcceptApproval
export const canPhotoApproval =
    UserHelper._shared().userAbilityHelper.canPhotoApproval
export const canProjectPhotoApproval =
    UserHelper._shared().userAbilityHelper.canProjectPhotoApproval
export const canGalleryPhotoApproval =
    UserHelper._shared().userAbilityHelper.canGalleryPhotoApproval
export const canPhotoReject =
    UserHelper._shared().userAbilityHelper.canPhotoReject
export const canProjectPhotoReject =
    UserHelper._shared().userAbilityHelper.canProjectPhotoReject
export const canGalleryPhotoReject =
    UserHelper._shared().userAbilityHelper.canGalleryPhotoReject
export const canPhotoPublish =
    UserHelper._shared().userAbilityHelper.canPhotoPublish
export const canProjectPhotoPublish =
    UserHelper._shared().userAbilityHelper.canProjectPhotoPublish
export const canGalleryPhotoPublish =
    UserHelper._shared().userAbilityHelper.canGalleryPhotoPublish
export const canGalleryPhotoSendInApproval =
    UserHelper._shared().userAbilityHelper.canGalleryPhotoSendInApproval
export const canPhotoSendInApproval =
    UserHelper._shared().userAbilityHelper.canPhotoSendInApproval
export const canSendInApprovalNews =
    UserHelper._shared().userAbilityHelper.canSendInApprovalNews
export const canSendInApprovalTask =
    UserHelper._shared().userAbilityHelper.canSendInApprovalTask
export const canCancel = UserHelper._shared().userAbilityHelper.canCancel
export const canCancelTask =
    UserHelper._shared().userAbilityHelper.canCancelTask
export const canCancelNews =
    UserHelper._shared().userAbilityHelper.canCancelNews
export const canRelease = UserHelper._shared().userAbilityHelper.canRelease
export const canReleaseTask =
    UserHelper._shared().userAbilityHelper.canReleaseTask
export const canReleaseNews =
    UserHelper._shared().userAbilityHelper.canReleaseNews
export const canClone = UserHelper._shared().userAbilityHelper.canClone
export const canCloneTask = UserHelper._shared().userAbilityHelper.canCloneTask
export const canCloneNews = UserHelper._shared().userAbilityHelper.canCloneNews
export const canClose = UserHelper._shared().userAbilityHelper.canClose
export const canClosePhoto = UserHelper._shared().userAbilityHelper.canClosePhoto
export const canGoToGallery = UserHelper._shared().userAbilityHelper.canGoToGallery
export const canCloseTask = UserHelper._shared().userAbilityHelper.canCloseTask
export const canCloseNews = UserHelper._shared().userAbilityHelper.canCloseNews
export const canRedo = UserHelper._shared().userAbilityHelper.canRedo
export const canRedoTask = UserHelper._shared().userAbilityHelper.canRedoTask
export const canRedoNews = UserHelper._shared().userAbilityHelper.canRedoNews
export const canDelegate = UserHelper._shared().userAbilityHelper.canDelegate
export const canDelegateTask =
    UserHelper._shared().userAbilityHelper.canDelegateTask
export const canDelegateNews =
    UserHelper._shared().userAbilityHelper.canDelegateNews
export const canReject = UserHelper._shared().userAbilityHelper.canReject
export const canRejecTask = UserHelper._shared().userAbilityHelper.canRejectTask
export const canRejectNews =
    UserHelper._shared().userAbilityHelper.canRejectNews
export const canExecuteQuestionTask =
    UserHelper._shared().userAbilityHelper.canExecuteQuestionTask
export const canExecuteJobTask =
    UserHelper._shared().userAbilityHelper.canExecuteJobTask
export const canExecuteSurveyTask =
    UserHelper._shared().userAbilityHelper.canExecuteSurveyTask
export const canExecuteSurvey =
    UserHelper._shared().userAbilityHelper.canExecuteSurvey
export const canConfirmReadingNews =
    UserHelper._shared().userAbilityHelper.canConfirmReadingNews
export const canAcceptExecution =
    UserHelper._shared().userAbilityHelper.canAcceptExecution
export const canUploadPhotoTask =
    UserHelper._shared().userAbilityHelper.canUploadPhotoTask
export const canRecall = UserHelper._shared().userAbilityHelper.canRecall
export const canRecallTask =
    UserHelper._shared().userAbilityHelper.canRecallTask
export const canRecallNews =
    UserHelper._shared().userAbilityHelper.canRecallNews
export const canCreateResource =
    UserHelper._shared().userAbilityHelper.canCreateResource
export const canCreateDocument =
    UserHelper._shared().userAbilityHelper.canCreateDocument
export const canCreateForm =
    UserHelper._shared().userAbilityHelper.canCreateForm
export const canEditResource =
    UserHelper._shared().userAbilityHelper.canEditResource
export const canEditDocument =
    UserHelper._shared().userAbilityHelper.canEditDocument
export const canEditForm = UserHelper._shared().userAbilityHelper.canEditForm
export const canDeleteResource =
    UserHelper._shared().userAbilityHelper.canDeleteResource
export const canDeleteDocument =
    UserHelper._shared().userAbilityHelper.canDeleteDocument
export const canDeleteForm =
    UserHelper._shared().userAbilityHelper.canDeleteForm
export const canMoveResource =
    UserHelper._shared().userAbilityHelper.canMoveResource
export const canMoveDocument =
    UserHelper._shared().userAbilityHelper.canMoveDocument
export const canMoveForm = UserHelper._shared().userAbilityHelper.canMoveForm
export const canEditProfiles =
    UserHelper._shared().userAbilityHelper.canEditProfiles
export const canDeleteThread =
    UserHelper._shared().userAbilityHelper.canDeleteThread
export const canDeleteTopic =
    UserHelper._shared().userAbilityHelper.canDeleteTopic
export const canViewReports =
    UserHelper._shared().userAbilityHelper.canViewReports
export const canCreateAlbum =
    UserHelper._shared().userAbilityHelper.canCreateAlbum
export const canEditAlbum =
    UserHelper._shared().userAbilityHelper.canEditAlbum
export const canDeleteAlbum =
    UserHelper._shared().userAbilityHelper.canDeleteAlbum
export const canViewProjectDetailsExtraInfo =
    UserHelper._shared().userAbilityHelper.canViewProjectDetailsExtraInfo
export const canEditAlias = UserHelper._shared().userAbilityHelper.canEditAlias
